<template>
  <v-list-item>
    <template v-if="startDateStr === endDateStr">
      <span>{{ startDateStr }}</span>
      <span> | {{ timeStr }}</span>
    </template>

    <template v-else>
      <span>{{ startDateStr }} – {{ endDateStr }}</span>
      <span> | {{ timeStr }}</span>
    </template>

    <v-chip
      v-if="occasion.product_variant && occasion.product_variant.person"
      class="ml-2"
      size="x-small"
    >
      {{ occasion.product_variant.person.name }}</v-chip
    >
    <v-chip
      v-if="
        occasion.product_variant && occasion.product_variant.delivery_method
      "
      class="ml-1"
      size="x-small"
    >
      {{ occasion.product_variant.delivery_method.name }}</v-chip
    >
  </v-list-item>
</template>

<script setup>
import { toRef } from 'vue'
import { useOccasion } from '#root/lib/useOccasion'

const props = defineProps({
  value: {
    required: true,
    type: Object
  }
})

const occasion = toRef(() => props.value)
const { startDateStr, endDateStr, timeStr } = useOccasion(occasion)
</script>
